<template>
  <div class="payment max-width">
    <div @click="payClick" :class="paymentBtn">
      <p>{{ text }}</p>
    </div>
  </div>
</template>
<script>
import utils from '@/utils/utils'
import {
  startPayment, showToast, closeSelf, showLoading, hideLoading
} from '@/utils/nativeBridge.js'
import { toastType } from '@/config/common'
import { getPaymentMethod } from '@/service/pageDetail'
import { changesvc } from '@/service/policyChangeService'
import store from '@/store'
const { toNum } = utils
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    currency: {
      type: String,
      default: ''
    },
    payamount: {
      type: [Number, String],
      default: 0
    },
    equalHKAmount: {
      type: [Number, String],
      default: 0
    },
    policyno: {
      type: String,
      default: ''
    },
    category: {
      type: [Number, String],
      default: 0
    },
    allowPay: {
      type: [Boolean],
      default: true
    },
    detail: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      payMethodList: []
    }
  },
  computed: {
    canPay () {
      if (toNum(this.payamount) <= 0 || !this.currency) return false
      return true
    },
    paymentBtn () {
      return {
        'payment-btn': true,
        'noactive-btn': !this.canPay
      }
    }
  },
  methods: {
    payClick () {
      if (!this.allowPay) { this.$emit('showWarning') }
      if (!this.canPay || !this.allowPay) return
      if (this.payMethodList.length) {
        this.startPayment()
        return
      }
      showLoading()
      getPaymentMethod(store.mmaclientid, this.policyno, this.category)
        .then(data => {
          // 付款方式
          this.payMethodList.splice(0, this.payMethodList.length)
          data.paymethods.forEach(item => {
            this.payMethodList.push(item.paymethods)
          })
          this.startPayment()
        })
        .catch(() => {
          showToast(this.$t('netErrorToast'), 1)
        })
        .finally(() => {
          hideLoading()
        })
    },
    startPayment () {
      startPayment({
        payMethodList: this.payMethodList,
        defaultMethod: this.payMethodList[0],
        currency: this.currency,
        amount: this.payamount,
        equalHKAmount: this.equalHKAmount,
        category: this.category,
        policyno: this.policyno,
        detail: this.detail
      })
        .then(({ result }) => {
          if (result === 'paramsError') {
            showToast(this.$t('netErrorToast'), toastType.error)
          } else if (result === 'success') {
            closeSelf()
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.payment {
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 68px;
  padding-bottom: 3px;
  background-color: $color-bg-white;
  .payment-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 345px;
    height: 44px;
    border-radius: 4px;
    background-color: $color-primary;
    p {
      color: $color-bg-white;
      font-size: $base-font-size;
      line-height: 16px;
      text-align: center;
      @include font-Semibold;
    }
  }
  .noactive-btn {
    opacity: 0.5;
  }
}
</style>
